module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABDElEQVQ4jaWTvUoEMRRGz6hgI/bi2tkKNoKNsI9g7xNsZ+mCWFhNYelPYe1L2FktyIKiLyC2NguKCCLHJkUck93szAdhktzcc79kuJUK0AM2KdMHMM5G1aHz6VElNyr1HVgJlX8KHD4De429feAW+CSqvD2t8pQxCPkjdXWh8N1yGgCXYf4KfHVxeBjl3qiLKm2BRylYW2AWlgNuqccFsOsmLAVcU9/C+kKtosOn0dmrRuxJfVF3Uw7rRGJqL3Y2CbF+7g1jwMMMWBEQ9cS/OsvAioHxT6gzoH/ApRmdUAMj4K60dUparxhWCpxL8ZUPgH5LznL4flfqPbDTxVXQBNio1B4wBNY7ws6B8S8TJAXOVjlxdwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/check-box.png
// module id = FLWz
// module chunks = 1